"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllOrders = void 0;
class GetAllOrders {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.getAllOrders(request);
    }
}
exports.GetAllOrders = GetAllOrders;
